// Dispatcher: the shared master list of delivery locations (replaces ACME List.xlsx).
import { listLocations, saveLocation, setLocationActive, importLocations } from '../lib/api.js';
import { geocode } from '../lib/routing.js';
import { $, $$, esc, busy, toast, makeMap, L } from '../lib/ui.js';

export async function renderLocations(app, { isNative }) {
  app.innerHTML = '<div class="side" id="side"></div><div class="map" id="map"></div>';
  const map = makeMap($('#map'));
  const layer = L.layerGroup().addTo(map);
  const side = $('#side');
  let all = [], filter = '', showInactive = false, pin = null;

  const clearPin = () => { if (pin) { map.removeLayer(pin); pin = null; } map.off('click'); };

  async function load() {
    try { all = await listLocations({ includeInactive: true }); }
    catch (e) { side.innerHTML = `<div class="err">${esc(e.message)}</div>`; return; }
    showList();
  }

  function showList() {
    clearPin();
    layer.clearLayers();
    const f = filter.toLowerCase();
    const rows = all.filter(l => (showInactive || l.active) && (!f || l.name.toLowerCase().includes(f) || l.address.toLowerCase().includes(f)));
    rows.forEach(l => {
      if (!Number.isFinite(l.lat)) return;
      layer.addLayer(L.circleMarker([l.lat, l.lng], { radius: 6, color: '#fff', weight: 2, fillColor: l.is_depot ? '#2e8b57' : l.active ? '#1a3c6e' : '#bbb', fillOpacity: 1 })
        .bindTooltip(esc(l.name)).on('click', () => showForm(l)));
    });
    const missing = all.filter(l => l.active && !Number.isFinite(l.lat)).length;
    side.innerHTML = `
      <div class="bar">
        <button class="primary" id="add">+ Add location</button>
        ${isNative ? '' : '<button id="imp">Import Excel</button><button id="exp">Export Excel</button><input type="file" id="file" accept=".xlsx" hidden>'}
      </div>
      <div class="bar" style="position:static">
        <input id="q" placeholder="Search name or address" value="${esc(filter)}" style="flex:1">
        <label><input type="checkbox" id="inact" ${showInactive ? 'checked' : ''}> inactive</label>
      </div>
      <div class="summary">${all.filter(l => l.active).length} active locations${missing ? ` · <b style="color:#b45309">${missing} without GPS</b>` : ''}</div>
      ${rows.map(l => `<div class="row ${l.active ? '' : 'done'}" data-id="${l.id}" style="cursor:pointer"><div class="grow">
        <div class="name">${l.is_depot ? '🏭 ' : ''}${esc(l.name)}</div>
        <div class="addr">${esc(l.address)}${Number.isFinite(l.lat) ? '' : ' <b style="color:#b45309">(no GPS)</b>'}</div>
        ${l.match_notes ? `<div class="hint" style="padding:2px 0 0">${esc(l.match_notes)}</div>` : ''}
      </div></div>`).join('')}`;
    const q = $('#q');
    q.oninput = () => { filter = q.value; showList(); const q2 = $('#q'); q2.focus(); q2.setSelectionRange(q2.value.length, q2.value.length); };
    $('#inact').onchange = e => { showInactive = e.target.checked; showList(); };
    $('#add').onclick = () => showForm(null);
    $$('[data-id]', side).forEach(r => r.onclick = () => showForm(all.find(l => l.id === r.dataset.id)));
    if (!isNative) {
      $('#imp').onclick = () => $('#file').click();
      $('#file').onchange = e => busy($('#imp'), () => doImport(e.target.files[0])).catch(() => {}).finally(() => { e.target.value = ''; });
      $('#exp').onclick = e => busy(e.target, async () => {
        const { downloadLocations } = await import('../lib/excel.js');
        await downloadLocations(all.filter(l => l.active), `ACME List ${new Date().toISOString().slice(0, 10)}.xlsx`);
      }).catch(() => {});
    }
  }

  async function doImport(file) {
    if (!file) return;
    const { readLocationsFile } = await import('../lib/excel.js');
    const rows = await readLocationsFile(file);
    if (!confirm(`Import ${rows.length} rows? Rows with the same name are updated, others added.`)) return;
    const r = await importLocations(rows);
    toast(`Imported: ${r.inserted} added, ${r.updated} updated.`);
    await load();
  }

  function showForm(loc) {
    const l = loc || { name: '', address: '', lat: null, lng: null, type: 'Destination', is_depot: false, active: true };
    layer.clearLayers();
    side.innerHTML = `
      <div class="bar"><button id="cancel">← Back</button></div>
      <div class="form">
        <h3>${loc ? 'Edit location' : 'Add location'}</h3>
        <input id="nm" placeholder="Shop name" value="${esc(l.name)}">
        <div style="display:flex;gap:6px"><input id="ad" placeholder="Address" value="${esc(l.address)}" style="flex:1"><button id="find">Find</button></div>
        <div id="results"></div>
        <p class="hint" style="padding:0">Search the address, or <b>tap the exact spot on the map</b>. Drag the pin to fine-tune.</p>
        <div class="addr">GPS: <span id="ll">${Number.isFinite(l.lat) ? `${l.lat.toFixed(6)}, ${l.lng.toFixed(6)}` : 'not set'}</span></div>
        <input id="notes" placeholder="Notes (optional)" value="${esc(l.match_notes || '')}">
        <button class="primary big" id="save">Save</button>
        ${loc && !l.is_depot ? `<button class="${l.active ? 'warn' : ''}" id="toggle">${l.active ? 'Deactivate' : 'Re-activate'}</button>` : ''}
      </div>`;
    const setPin = (lat, lng, zoom = true) => {
      if (pin) pin.setLatLng([lat, lng]);
      else {
        pin = L.marker([lat, lng], { draggable: true }).addTo(map);
        pin.on('dragend', () => { const p = pin.getLatLng(); $('#ll').textContent = `${p.lat.toFixed(6)}, ${p.lng.toFixed(6)}`; });
      }
      $('#ll').textContent = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      if (zoom) map.setView([lat, lng], Math.max(map.getZoom(), 16));
    };
    if (Number.isFinite(l.lat)) setPin(l.lat, l.lng);
    map.on('click', e => setPin(e.latlng.lat, e.latlng.lng, false));
    $('#cancel').onclick = showList;
    $('#find').onclick = e => busy(e.target, async () => {
      const hits = await geocode($('#ad').value.trim() || $('#nm').value.trim());
      if (!hits.length) { $('#results').innerHTML = '<p class="hint" style="padding:0">Not found — tap the spot on the map instead.</p>'; return; }
      $('#results').innerHTML = hits.map((h, i) => `<div class="row" data-h="${i}" style="cursor:pointer;padding:6px 0"><div class="addr">${esc(h.label)}</div></div>`).join('');
      $$('[data-h]', side).forEach(r => r.onclick = () => { const h = hits[+r.dataset.h]; setPin(h.lat, h.lng); });
      setPin(hits[0].lat, hits[0].lng);
    }).catch(() => {});
    $('#save').onclick = e => busy(e.target, async () => {
      const name = $('#nm').value.trim();
      if (!name) throw new Error('Enter the shop name.');
      if (!pin) throw new Error('Set the location on the map first.');
      const p = pin.getLatLng();
      await saveLocation({
        ...(loc ? { id: loc.id } : {}), name, address: $('#ad').value.trim() || 'Pinned on map',
        lat: +p.lat.toFixed(6), lng: +p.lng.toFixed(6), match_notes: $('#notes').value.trim() || null,
      });
      toast('Saved.');
      await load();
    }).catch(() => {});
    const t = $('#toggle');
    if (t) t.onclick = () => busy(t, async () => { await setLocationActive(loc.id, !loc.active); await load(); }).catch(() => {});
  }

  await load();
  return () => { clearPin(); map.destroy(); };
}
